import { IDict } from "./types";

export const en: IDict = {
  "Import Karaoke File": "Import Karaoke File",
  "dialogs.import_karaoke.title": "Import Karaoke from File",
  "dialogs.import_karaoke.description":
    "Import an existing karaoke file, like an MP3/MP4 with embedded lyrics, an LRC file with the same name, or a Karafun file.",
  optional: "optional",
  Jobs: "Jobs",
  "No Jobs": "No Jobs",
  Billing: "Billing",
  Credits: "Credits",
  "Pay Per Use": "Pay Per Use",
  "Feature Voting": "Feature Voting",
  "Free Karaoke Left": "Free Karaoke Left",
  "Upgrade Now to Create More": "Upgrade Now to Create More",
  "Storage is Full": "Storage is Full",
  "Youka is running out of storage space":
    "Youka is running out of storage space",
  "Please free up at least 1 GB before creating new karaoke":
    "Please free up at least 1 GB before creating new karaoke",
  "Click the button to check again": "Click the button to check again",
  "No Internet Connection": "No Internet Connection",
  "Youka cannot connect to the internet":
    "Youka cannot connect to the internet",
  "Please make sure you have internet connection":
    "Please make sure you have internet connection",
  "Update is ready": "Update is ready",
  "Click the button to update": "Click the button to update",
  "Library Folder": "Library Folder",
  "Export Folder": "Export Folder",
  "Sync Model": "Sync Model",
  "Max Video Quality": "Max Video Quality",
  "Speed / Compression Preset": "Speed / Compression Preset",
  Change: "Change",
  "dialogs.upgrade.upgrade_to_pro":
    "The feature you're looking for is part of the Pro plan, upgrade now to unlock this feature.",
  "dialogs.upgrade.upgrade_to_standard":
    "The feature you're looking for is part of the Standard plan, upgrade now to unlock this feature.",

  heads_up: "Heads up!",
  "dialogs.edit_lyrics.not_supported":
    "The language you've chosen is currently not supported for automatic lyrics synchronization. However, you can save your progress and then utilize the Line Level Editor to synchronize the lyrics manually.",
  "dialogs.create.title": "Create new karaoke",
  "dialogs.create.description":
    "Please fill in the form below to create a new karaoke, you can use audio or video file, lyrics are optional.",
  "dialogs.edit_lyrics.description":
    "After saving, the sync process will be started, you can follow the progress in the Jobs tab",
  "dialogs.upgrade.see_plans": "See Plans",
  "dialogs.upgrade.unlock": "Unlock",

  "comps.sync_editor.attach_previous": "Attach to the previous word",
  "comps.sync_editor.attach_next": "Attach to the next word",
  "comps.plans.title":
    "Choose the plan that best fits your needs. You can always upgrade or downgrade",
  "Font Size": "Font Size",
  Spacing: "Spacing",
  Outline: "Outline",
  "Margin Bottom": "Margin Bottom",
  "Max Chars per Line": "Max Chars per Line",
  Bold: "Bold",
  Italic: "Italic",
  Shadow: "Shadow",
  month: "month",
  songs: "songs",
  Title: "Title",
  "Save and Sync": "Save and Sync",
  Lyrics: "Lyrics",
  Update: "Update",
  Playlist: "Playlist",
  Canceling: "Canceling",
  Play: "Play",
  "Lyrics Language": "Lyrics Language",
  "Background Image": "Background Image",
  "Basic Version": "Basic Version",
  "Standard Version": "Standard Version",
  "Pro Version": "Pro Version",
  "Trial Version": "Trial Version",
  "No Active Plan": "No Active Plan",
  "Days Left in Trial": "Days Left in Trial",
  Paste: "Paste",
  "Sync Lyrics": "Sync Lyrics",
  Show: "Show",
  Settings: "Settings",
  Retry: "Retry",
  "Create Karaoke": "Create Karaoke",
  Canceled: "Canceled",
  Reset: "Reset",
  "Edit Video": "Edit Video",
  Download: "Download",
  "Edit Metadata": "Edit Metadata",
  "Subtitle Designer": "Subtitle Designer",
  Export: "Export",
  year: "year",
  Basic: "Basic",
  Standard: "Standard",
  Pro: "Pro",
  Accept: "Accept",
  "Add new word": "Add new word",
  "Add to queue": "Add to queue",
  "An unknown error occurred": "An unknown error occurred",
  Annually: "Annually",
  "Are you sure you want to delete this karaoke song?":
    "Are you sure you want to delete this karaoke song?",
  "Artist Name": "Artist Name",
  "Audio or Video File": "Audio or Video File",
  Audio: "Audio",
  "Auto Karaoke Generator": "Auto Karaoke Generator",
  "Auto Lyrics Sync": "Auto Lyrics Sync",
  "Cancel Plan": "Cancel Plan",
  Cancel: "Cancel",
  Close: "Close",
  "Create Karaoke from song": "Create Karaoke from Song",
  "Create Karaoke from local files": "Create Karaoke from local files",
  "Create new karaoke": "Create new karaoke",
  Create: "Create",
  "Current Plan": "Current Plan",
  "Dark Mode": "Dark Mode",
  Decline: "Decline",
  "Delete word": "Delete word",
  Delete: "Delete",
  "Edit Lyrics": "Edit Lyrics",
  Edit: "Edit",
  "Export to mp3/mp4": "Export to mp3/mp4",
  "Go Back to EULA": "Go Back to EULA",
  "Go back": "Go back",
  "Go forward": "Go forward",
  Home: "Home",
  "I accept the terms and commit to avoiding unlicensed use of copyrighted content":
    "I accept the terms and commit to avoiding unlicensed use of copyrighted content",
  Instruments: "Instruments",
  Key: "Key",
  Library: "Library",
  "Light Mode": "Light Mode",
  "Line Level Sync": "Line Level Sync",
  "Line Level": "Line Level",
  "Lyrics (optional)": "Lyrics (optional)",
  "Lyrics Sync Editor": "Lyrics Sync Editor",
  Manage: "Manage",
  Monthly: "Monthly",
  "Most popular": "Most popular",
  "No new notifications": "No new notifications",
  "No results": "No results",
  "No songs in library": "No songs in library",
  "No songs in queue": "No songs in queue",
  Notifications: "Notifications",
  Off: "Off",
  Or: "Or",
  "Plan canceled, will end in": "Plan canceled, will end in",
  "Play word in loop": "Play word in loop",
  "Preparing Youka": "Preparing Youka",
  "Process 2 karaokes at a time": "Process 2 karaokes at a time",
  "Process 5 karaokes at a time": "Process 5 karaokes at a time",
  Queue: "Queue",
  Ready: "Ready",
  "Remove from queue": "Remove from queue",
  "Resume plan": "Resume plan",
  "Save and Resync": "Save and Resync",
  Save: "Save",
  "Saving...": "Saving...",
  Search: "Search",
  "Select plan": "Select plan",
  "Sign In": "Sign In",
  "Sign Out": "Sign Out",
  "Sign Up": "Sign Up",
  "Song Name": "Song Name",
  "Start typing to search or paste YouTube URL":
    "Start typing to search or paste YouTube URL",
  "Start typing to search": "Start typing to search",
  "Subtitle Track": "Subtitle Track",
  Subtitles: "Subtitles",
  Tempo: "Tempo",
  "Terms and Conditions": "Terms and Conditions",
  "This action cannot be undone.": "This action cannot be undone.",
  "Thumbnail URL": "Thumbnail URL",
  "To keep the karaoke fun going, please upgrade":
    "To keep the karaoke fun going, please upgrade",
  "Unlock Premium Features with an Upgrade!":
    "Unlock Premium Features with an Upgrade!",
  "Update Payment Method": "Update Payment Method",
  "Upgrade to Pro plan to enable": "Upgrade to Pro plan to enable",
  Upgrade: "Upgrade",
  Version: "Version",
  Video: "Video",
  Vocals: "Vocals",
  "Waiting in queue": "Waiting in queue",
  "Word Level Sync": "Word Level Sync",
  "Word Level": "Word Level",
  "You need to accept the EULA to use Youka":
    "You need to accept the EULA to use Youka",
  "Your lyrics have been saved successfully. A resync is currently in progress. You can monitor the progress in the notification area. Once the resync is complete, you'll be able to see the changes - just hit 'play'.":
    "Your lyrics have been saved successfully. A resync is currently in progress. You can monitor the progress in the notification area. Once the resync is complete, you'll be able to see the changes - just hit 'play'.",
  "Your trial version of Youka has expired":
    "Your trial version of Youka has expired",
  "dialogs.youtube.title":
    "Install yt-dlp plugin to search and play online videos",
  "dialogs.youtube.description":
    "Please read and accept the following warnings before enabling the plugin.",
  "dialogs.youtube.agree": "I have read and understood the above warnings",
  "dialogs.youtube.install": "Install Plugin",
  "dialogs.youtube.install_success": "Plugin installed successfully",
  "dialogs.youtube.install_success_description":
    "You can now search and play online videos",
  "dialogs.youtube.install_error": "Plugin installation failed",
  "alert.youtube.description":
    "Online Video Search and Download Plugin (yt-dlp) is not pre-installed. Please click to install the plugin.",
  "alert.youtube.install": "Install Plugin",
  "dialogs.settings.enable_youtube": "Enable yt-dlp Plugin",

  "dialogs.youtube.warnings": [
    {
      title: "Legal Compliance",
      description:
        "Ensure that your use of this plugin is in full compliance with all applicable laws and the terms of service of any platforms you interact with, such as YouTube.",
    },
    {
      title: "Copyright and Licensing",
      description:
        "This plugin may allow actions (like downloading content) that could infringe on copyright laws or violate licensing agreements if not used properly. It's crucial to respect the rights of content creators and only use the plugin for legally permissible purposes.",
    },
    {
      title: "No Endorsement",
      description:
        "Enabling this plugin does not imply endorsement or support by our company. The plugin is a separate entity and we are not responsible for its operation or any consequences of its use.",
    },
    {
      title: "User Responsibility",
      description:
        "You are solely responsible for any actions you take using this plugin. This includes any legal consequences that may arise due to misuse or violation of terms of service.",
    },
    {
      title: "Potential Risks",
      description:
        "Be aware that misuse of the plugin could lead to account suspension or legal action by affected parties or platforms.",
    },
    {
      title: "Informed Consent",
      description:
        "By proceeding to enable this plugin, you acknowledge that you have read and understood these warnings and accept full responsibility for your use of the plugin.",
    },
  ],
  "model.auto": "Automatically select the best model.",
  "model.audioshake.transcription":
    "The 1st best model, which involves transcribing and then aligning, delivers superior results but is accessible exclusively to Pay Per Use and Trial users (taking up to 10 minutes).",
  "model.audioshake":
    "The 2nd best model, aligns with the supplied lyrics, where inaccuracies can lead to suboptimal outcomes (taking up to 10 minutes).",
  "model.wav2vec2":
    "The 3rd best model, aligns with the supplied lyrics, where inaccuracies can lead to suboptimal outcomes, supports almost all languages. (taking up to 30 seconds)",
  "model.whisper":
    "The 4th best model, which involves transcribing and then aligning. The output lyrics may not be accurate, though the synchronization is acceptable (taking up to 2 minutes).",
  "sync.line.instructions": [
    "Click on the Play button to play the song and start the sync process",
    "Click on the Set Start button when you hear the first word of current line",
    "Click on the Set End button after you hear the last word of current line",
    "Continue until you finish to sync all the lines",
  ],
  Undo: "Undo",
  Redo: "Redo",
  "Set Start": "Set Start",
  "Set End": "Set End",
  "dialogs.edit_lyrics.transcription":
    "When utilizing the transcription model, the model independently transcribes the song and identifies the lyrics on its own, without relying on any provided lyrics. Afterwards, you have the option to adjust the lyrics using the sync tool.",
  "Duet Editor": "Duet Editor",
  "Manual Line Sync": "Manual Line Sync",
  "New Style": "New Style",
  Style: "Style",
  Singer: "Singer",
  "Style Editor": "Style Editor",
  Word: "Word",
  Line: "Line",
  "Split Line": "Split Line",
  "Upgrade to Enable": "Upgrade to Enable",
  upgrade_description:
    "You have the option to listen to or download the karaoke tracks you've already generated. However, if you wish to create additional karaoke tracks, an upgrade is required.",
  "dialogs.global.no_user.title": "No Active Plan",
  "dialogs.global.no_user.description": "Please upgrade to a plan to continue",
  "dialogs.global.no_role.title": "No Active Plan",
  "dialogs.global.no_role.description": "Please upgrade to a plan to continue",
  "dialogs.global.blocked_ip.title": "Your IP is blocked",
  "dialogs.global.blocked_ip.description": "Please contact support",
  "dialogs.global.rate_limit.title": "Rate Limit Exceeded",
  "dialogs.global.rate_limit.description":
    "You can switch to a Pay Per Use plan for unlimited access.",
  "dialogs.global.disk_full.title": "Storage is Full",
  "dialogs.global.disk_full.description":
    "Please free up some space to continue using Youka",
  "dialogs.global.too_big.title": "Audio File Exceeds Size Limit",
  "dialogs.global.too_big.description":
    "Please note that the audio file cannot exceed a maximum duration of 15 minutes.",
  Help: "Help",
  Original: "Original",
  Sort: "Sort",
  "sort.date.asc": "Creation Date (Oldest to Newest)",
  "sort.date.desc": "Creation Date (Newest to Oldest)",
  "sort.title.asc": "Title (A to Z)",
  "sort.title.desc": "Title (Z to A)",
  "dialogs.trim.title": "Trim",
  "dialogs.trim.description":
    "Use the adjustable border on the waveform to choose the part of the song you want to keep.",
  Start: "Start",
  End: "End",
  Time: "Time",
  Related: "Related",
  preserve_vocals: "Preserve Vocals",
  preserve_vocals_description:
    "Toggle this to preserve vocals like backing vocals.",
  "Separate Audio": "Separate Audio",
  "Separate Model": "Separate Model",
  "Add Lyrics": "Add Lyrics",
  "Background Image or Video": "Background Image or Video",
  Docs: "Docs",
  Watch: "Watch",
  Hide: "Hide",
  "watch.sync.title": "How to fix lyrics sync easily?",
  "watch.sync.url": "https://www.youtube.com/watch?v=kEHzfAwQBzo",
  "watch.review.title": "Review Youka on Trustpilot",
  Review: "Review",
  "Import Subtitles": "Import Subtitles",
  Import: "Import",
  "How to use": "How to use",
  Uppercase: "Uppercase",
  "Open Dual Screen": "Open Dual Screen",
  "Close Dual Screen": "Close Dual Screen",
  "Trial Expired": "Trial Expired",

  "Subtitles Settings": "Subtitles Settings",
  Milliseconds: "Milliseconds",
  Seconds: "Seconds",
  Text: "Text",
  Enabled: "Enabled",
  Duration: "Duration",
  Gap: "Gap",
  Offset: "Offset",
  "Min Duration": "Min Duration",
  "Max Duration": "Max Duration",
  "Fade In": "Fade In",
  "Fade Out": "Fade Out",
  "plugins.title.title": "Song Title",
  "plugins.title.description":
    "Insert the song title in the beginning of the video",
  "plugins.gap_text.title": "Silent Gap Text",
  "plugins.gap_text.description":
    "Insert the text in the gap between subtitles",
  "plugins.gap_progress_bar.title": "Silent Gap Progress Bar",
  "plugins.gap_progress_bar.description":
    "Insert a progress bar in the gap between subtitles",
  "plugins.fade.title": "Fade Effect",
  "plugins.fade.description": "Add fade in and fade out effect to subtitles",
  "plugins.offset.title": "Offset",
  "plugins.offset.description":
    "Offset the subtitles by a certain amount of seconds",
  "plugins.countdown.title": "Silent Gap Countdown",
  "plugins.countdown.description":
    "Insert a countdown in the gap between subtitles",
  Auto: "Auto",
  Subword: "Subword",
  Countdown: "Countdown",
  "Restart required": "Restart required",
  "Reindex Library": "Reindex Library",
  "Create playlist": "Create playlist",
  "Are you sure you want to delete?": "Are you sure you want to delete?",
  "Add to playlist": "Add to playlist",
  "New playlist": "New playlist",
  "Remove from this playlist": "Remove from this playlist",
  Songs: "Songs",
  Playlists: "Playlists",
  Name: "Name",
  Photo: "Photo",
  "No playlists": "No playlists",
  "Welcome to Youka": "Welcome to Youka",
  "Search songs online": "Search songs online",
  "create.file.title": "Create Karaoke from File",
  "create.file.description":
    "Upload your MP3, MP4, or other files to instantly create a karaoke video with synchronized lyrics.",
  "create.online.title": "Create Karaoke from URL",
  "create.online.description":
    "Paste a song URL to instantly create a karaoke video with synchronized lyrics.",
  "Change Background": "Change Background",
  "Duet Line Split": "Duet Line Split",
  Both: "Both",
  Custom: "Custom",
  Edited: "Edited",
  Trimmed: "Trimmed",
  Instrumental: "Instrumental",
  "Add Subword": "Add Subword",
  "plugins.max_chars.title": "Max Characters Per Line",
  "plugins.max_chars.description": "Limit the number of characters per line",
  Limit: "Limit",
  "Background Box": "Background Box",
  Height: "Height",
  Width: "Width",
  Alpha: "Alpha",
  Color: "Color",
  Duplicate: "Duplicate",
  "Convert to 16x9": "Convert to 16x9",
  "Resize Video": "Resize Video",
  "Line Alignment": "Line Alignment",
  "Shadow Color": "Shadow Color",
  "Outline Color": "Outline Color",
  "Active Color": "Active Color",
  "Secondary Color": "Secondary Color",
  "Primary Color": "Primary Color",
  "Auto Alignment": "Auto Alignment",
  "Auto Color": "Auto Color",
  "Singer 1": "Singer 1",
  "Singer 2": "Singer 2",
  "Top Row": "Top Row",
  "Bottom Row": "Bottom Row",
  "Border Style": "Border Style",
  "Font Name": "Font Name",
  "Experimental Subtitles Display": "Experimental Subtitles Display",
  Position: "Position",
  "Timing Indicator": "Timing Indicator",
  General: "General",
  Styles: "Styles",
  Thumbnail: "Thumbnail",
  "create.url.title": "Create Karaoke from URL",
  "create.url.description": "Create karaoke from a yt-dlp supported URL",
  "Paste a URL or start typing to search":
    "Paste a URL or start typing to search",
  Top: "Top",
  Bottom: "Bottom",
  Center: "Center",
  "Auto Line Break": "Auto Line Break",
  "Fill Color": "Fill Color",
  "Active Line Color": "Active Line Color",
  "Waiting Line Color": "Waiting Line Color",
  "Set as Default": "Set as Default",
  Default: "Default",
  "Make Default": "Make Default",
  Image: "Image",
  Pause: "Pause",
  File: "File",
  "Debug Info": "Debug Info",
  "File Type": "File Type",
  Language: "Language",
  "Reset Settings": "Reset Settings",
  "Failed to start Youka": "Failed to start Youka",
  Legacy: "Legacy",
  Transcription: "Transcription",
  Alignment: "Alignment",
  Imported: "Imported",
  "With Backing Vocals": "With Backing Vocals",
  Stem: "Stem",
  Clear: "Clear",
  "Open Directory": "Open Directory",
  "Advanced Settings": "Advanced Settings",
  "How to Add a Background Black Box to Subtitles":
    "How to Add a Background Black Box to Subtitles",
  "How to Adjust the Line Length": "How to Adjust the Line Length",
  "How to Cancel Your Subscription": "How to Cancel Your Subscription",
  "How to Center Subtitles": "How to Center Subtitles",
  "How to Delete a Karaoke": "How to Delete a Karaoke",
  "How to Edit the lyrics": "How to Edit the lyrics",
  "How to Fix the Sync": "How to Fix the Sync",
  "How to Keep Choirs": "How to Keep Choirs",
  "How to Keep the Original Singer’s Voice":
    "How to Keep the Original Singer’s Voice",
  "How to Set Up a Duet": "How to Set Up a Duet",
  "How to Speed Up the Download Process":
    "How to Speed Up the Download Process",
  "How to Transfer Your Karaoke Library to a New Computer":
    "How to Transfer Your Karaoke Library to a New Computer",
  "How to Trim a Karaoke Video": "How to Trim a Karaoke Video",
  FAQ: "FAQ",
  "library.description":
    "Access and manage all the karaoke tracks you’ve created. Edit, organize, and perfect your projects.",
  "How to Change the Background Video": "How to Change the Background Video",
  "Auto Size": "Auto Size",
  "dialogs.global.no_credits.title": "No Credits Available",
  "dialogs.global.no_credits.description": "Please top up credits to continue",
  "Credits are over! Click to buy more": "Credits are over! Click to buy more",
  "How to Add a Line Break": "How to Add a Line Break",
  "dialogs.global.no_user.many_emails_description":
    "Access has been blocked due to multiple sign-ins using different email addresses. Please purchase a subscription to continue.",
  "dialogs.global.no_user.virtual_machine_description":
    "Access has been blocked because you're using a Virtual Machine. To access the free trial, please install Youka on a standard operating system. If you have a subscription, please renew it to regain access. If you don't need ongoing karaoke generation, you can opt for a pay-per-use plan, ensuring you’re only charged when you create new karaoke content.",
  "Import Stem": "Import Stem",
  "Active Outline Color": "Active Outline Color",
  "Inactive Outline Color": "Inactive Outline Color",
  "Inactive Line Color": "Inactive Line Color",
  "Active Line": "Active Line",
  "Inactive Line": "Inactive Line",
  "End Extra": "End Extra",
  Expand: "Expand",
  Collapse: "Collapse",
  "Copy Line": "Copy Line",
  "Copy Word": "Copy Word",
  "Cut Line": "Cut Line",
  "Cut Word": "Cut Word",
  "Delete Line": "Delete Line",
  "Delete Subword": "Delete Subword",
  "Delete Word": "Delete Word",
  "Add Line": "Add Line",
  "Add Word": "Add Word",
  "Paste Line": "Paste Line",
  "Paste Word": "Paste Word",
  "Paste Subword": "Paste Subword",
  "Play Line": "Play Line",
  "Play Word": "Play Word",
  "Select Line": "Select Line",
  "Manual Sync": "Manual Sync",
  "Trim Start": "Trim Start",
  "Trim End": "Trim End",
  "Creating will use 1 credit": "Creating will use 1 credit",
  All: "All",
  "Number of Singers": "Number of Singers",
  "Style Mapping": "Style Mapping",
  "Associate subtitle styles with singers":
    "Associate subtitle styles with singers",
  "Upper first line": "Upper first line",
  "Upper second line": "Upper second line",
  "Lower first line": "Lower first line",
  "Lower second line": "Lower second line",
  Lock: "Lock",
  "2 Lines": "2 Lines",
  "4 Lines": "4 Lines",
  Static: "Static",
  Dynamic: "Dynamic",
  "Subtitles Type": "Subtitles Type",
  "Danger Zone": "Danger Zone",
  Copy: "Copy",
  Copied: "Copied",
  "Copy Settings": "Copy Settings",
  "cta.social.title": "Get 50 credits for FREE!",
  "cta.social.description":
    "Share a post about Youka on social media, tag us, and earn 50 free credits per platform!",
  "cta.social.description.2":
    "Click to visit Youka's Facebook page, give it a like, share a post, and send your email in the chat to receive 50 free credits!",
  "Merge Line": "Merge Line",
  Player: "Player",
  "Key Step": "Key Step",
  "Tempo Step": "Tempo Step",
  "Shift Line Forward": "Shift Line Forward",
  "Shift Line Backward": "Shift Line Backward",
  "create.description":
    "Create karaoke from audio or video files (MP3, MP4, and more), or paste a URL to instantly generate a karaoke video with synchronized lyrics.",
  "No file chosen": "No file chosen",
  "Choose File": "Choose File",
  "Watch Quick Start Video": "Watch Quick Start Video",
  "Export Settings": "Export Settings",
  "Import Settings": "Import Settings",
  "Video Guides": "Video Guides",
  "Quick Start Guide": "Quick Start Guide",
  "Lyrics Sync Guide": "Lyrics Sync Guide",
  Resolution: "Resolution",
  "Subtitles Preset": "Subtitles Preset",
  Preset: "Preset",
  Done: "Done",
  "New Style Mapping": "New Style Mapping",
  Horizontal: "Horizontal",
  Vertical: "Vertical",
  Square: "Square",
  New: "New",
  "New Subtitles Preset": "New Subtitles Preset",
  "Change Aspect Ratio": "Change Aspect Ratio",
  "copyright.title.a": "I accept the",
  "copyright.title.b": "Music Usage Confirmation",
  "copyright.description":
    "By checking this box, you confirm that (A) you own all of the rights to the music included in this video; or (B) the music is in the public domain; or (C) you have permission from all necessary rights holders to use the music on the Youka platform.",
  "Add Intro Video": "Add Intro Video",
  "dialogs.intro.description":
    "Add a custom video to the beginning of the karaoke",
  Transition: "Transition",
  Fade: "Fade",
  "Circle Open": "Circle Open",
  "Circle Close": "Circle Close",
  "Diagonal Open": "Diagonal Open",
  "Diagonal Close": "Diagonal Close",
  "Smooth Left": "Smooth Left",
  "Smooth Right": "Smooth Right",
  Squares: "Squares",
  Dissolve: "Dissolve",
  Type: "Type",
  "Song Title": "Song Title",
  Artists: "Artists",
  Artist: "Artist",
  "Parse Titles": "Parse Titles",
  "sort.artist.asc": "Artist (A to Z)",
  "sort.artist.desc": "Artist (Z to A)",
  "Title Style": "Title Style",
  "Artist Style": "Artist Style",
  "Analyse Library": "Analyse Library",
  "No Filter": "No Filter",
  "credits.message_one": "This will use {{count}} credit",
  "credits.message_other": "This will use {{count}} credits",
  "credits.badge_one": "{{count}} credit",
  "credits.badge_other": "{{count}} credits",
  "Provide song lyrics to save credits": "Provide song lyrics to save credits",
  "Upload to Cloud Library": "Upload to Cloud Library",
  "Cloud Library": "Cloud Library",
  "Open Cloud Library": "Open Cloud Library",
};
